import _ from 'underscore';

const ELIGIBLE = 'Eligible';
const INLINE_OPPORTUNITY = 'InlineOpportunity';
const AUTO_BIDDING_LIMITED = 'AutoBiddingLimitedUnAttainableTarget';
const enabledStatuses = [ELIGIBLE, INLINE_OPPORTUNITY, AUTO_BIDDING_LIMITED];
const autoBiddingTargets = ['TargetCpa', 'TargetRoas'];
const maxConversionTargets = ['MaxConversionValue', 'MaxConversions'];

export const getEnabledBidLandscape = (value = {}) => {
  const enabledBidLandscapeForLimited = value.DeliveryStatus === AUTO_BIDDING_LIMITED
    && _.every(value.DeliveryStatusDetails, detail => _.contains(enabledStatuses, detail));
  return (
    value.DeliveryStatus === ELIGIBLE
      || value.DeliveryStatus === INLINE_OPPORTUNITY
      || enabledBidLandscapeForLimited
  ) && value.IsBidLandscapeAvailable;
};

const getWhiteList = permissions => [
  'ManualCpc',
  'EnhancedCpc',
  ...permissions.dynamic && permissions.dynamic.SimulatorForCPAROAS
    ? autoBiddingTargets
    : [],
  ...permissions.IsPmaxBidLandscapeEnabled
    ? maxConversionTargets
    : [],
];

export const getHasBidLandscapeIcon = ({
  biddingSchemeType,
  inWhiteList,
  permissions = {},
  value = {},
}) => {
  let hasBidLandscapeIcon = !permissions.IsReadOnlyUser
    && inWhiteList
    && !value.BidStrategyName; // portfolio campaign has no support

  if (_.contains(autoBiddingTargets, biddingSchemeType)) {
    hasBidLandscapeIcon = hasBidLandscapeIcon && !value.Budget.Id;
  }

  if (_.contains(maxConversionTargets, biddingSchemeType)) {
    hasBidLandscapeIcon = hasBidLandscapeIcon && (
      !_.isNull(_.result(value.BiddingScheme, 'TargetCpa', null))
        || !_.isNull(_.result(value.BiddingScheme, 'TargetRoas', null))
    );
  }

  return hasBidLandscapeIcon;
};

export const getBidLandscapeConfigs = ({
  permissions = {},
  value = {},
}) => {
  if (!permissions.dynamic || !permissions.dynamic.NewBidLandscapeEntryPoints) {
    return {
      enabledBidLandscape: false,
      hasBidLandscapeIcon: false,
    };
  }

  const enabledBidLandscape = getEnabledBidLandscape(value);
  const whiteList = getWhiteList(permissions);
  const biddingSchemeType = _.result(value.BiddingScheme, 'Type', null);
  const inWhiteList = _.contains(whiteList, biddingSchemeType);
  const hasBidLandscapeIcon = getHasBidLandscapeIcon({
    biddingSchemeType,
    inWhiteList,
    permissions,
    value,
  });

  return {
    enabledBidLandscape,
    hasBidLandscapeIcon,
  };
};
